<div class="hr-layout">
  <!-- Sidebar -->
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo-container">
        <!-- Display company initials dynamically -->
        <div class="logo-placeholder" [class.loading]="isLoading">
          <ng-container *ngIf="(companyInitials$ | async) as initials; else defaultInitials">
            {{ initials }}
          </ng-container>
          <ng-template #defaultInitials>HR</ng-template>
        </div>
      </div>
      <h2>
        <ng-container *ngIf="(companyName$ | async) as name; else defaultName">
          {{ name }}
        </ng-container>
        <ng-template #defaultName>HR Panel</ng-template>
        
      </h2>
    </div>
    <div class="sidebar-menu">
      <ul>
        <li>
          <a routerLink="dashboard" routerLinkActive="active">
            <fa-icon [icon]="faTachometerAlt"></fa-icon>
            <span>Dashboard</span>
          </a>
        </li>
        <li>
          <a routerLink="employees" routerLinkActive="active">
            <fa-icon [icon]="faUsers"></fa-icon>
            <span>Employees</span>
          </a>
        </li>
        <li>
          <a routerLink="document-tracking" routerLinkActive="active">
            <fa-icon [icon]="faFileAlt"></fa-icon>
            <span>Document Tracking</span>
          </a>
        </li>
        <li>
          <a routerLink="cv-pool" routerLinkActive="active">
            <fa-icon [icon]="faIdCard"></fa-icon>
            <span>CV Pool</span>
          </a>
        </li>
        <li>
          <a routerLink="personal-tracking" routerLinkActive="active">
            <fa-icon [icon]="faCalendarAlt"></fa-icon>
            <span>Personal Events</span>
          </a>
        </li>
        <li>
          <a routerLink="notifications" routerLinkActive="active">
            <fa-icon [icon]="faBell"></fa-icon>
            <span>Notifications</span>
          </a>
        </li>
        <li>
          <a routerLink="document-type" routerLinkActive="active">
            <fa-icon [icon]="faFileAlt"></fa-icon>
            <span>Document Type</span>
          </a>
        </li>
        <li>
          <a routerLink="departments" routerLinkActive="active">
            <fa-icon [icon]="faBuilding"></fa-icon>
            <span>Departments</span>
          </a>
        </li>
        <li>
          <a routerLink="avatar" routerLinkActive="active">
            <fa-icon [icon]="faVideo"></fa-icon>
            <span>Avatar</span>
          </a>
        </li>
        <!-- Only show register button for superusers -->
        <li *ngIf="isSuperuser">
          <a routerLink="register" routerLinkActive="active">
            <fa-icon [icon]="faUserPlus"></fa-icon>
            <span>Register Company</span>
          </a>
        </li>
        
      </ul>

      <!-- Logout button -->
      <div class="sidebar-footer">
        <button class="logout-btn" (click)="logout()" title="Logout">
          <fa-icon [icon]="faSignOutAlt"></fa-icon>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <div class="header">
      <div class="header-top">
        <h1>Human Resources</h1>
        <div class="user-menu">
          <span class="user-greeting">Welcome, {{ userName }}</span>
          <div class="user-avatar" (click)="navigateToProfile()">{{ userName.charAt(0) }}</div>
        </div>
      </div>
      <div class="breadcrumb-container">
        <nav class="breadcrumb">
          <span class="breadcrumb-item">HR</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item active">
            <ng-container *ngIf="currentRoute; else defaultRoute">
              {{ currentRoute | titlecase }}
            </ng-container>
            <ng-template #defaultRoute>Dashboard</ng-template>
          </span>
        </nav>
      </div>
    </div>

    <div class="content-container">
      <div class="content-card">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
